import { debounce } from 'lodash';

export default {
  data() {
    const data = {
      project: null,
      projects: [],
    };
    data.projects.allProjectsItem = { ID: null, Name: 'All Projects' };
    data.projects.default = data.projects.allProjectsItem;
    data.projects.byId = {};
    return data;
  },
  methods: {
    getProjects(withAll = false) {
      return withAll ? [this.projects.allProjectsItem, ...this.projects] : this.projects;
    },
    async fetchProjects() {
      this.$startLoading('projects');

      const projects = await this.$api.projects.active();
      projects.allProjectsItem = this.projects.allProjectsItem;
      projects.default = this.projects.default;
      projects.byId = projects.reduce((acc, project) => ({ ...acc, [project.ID]: project }), {});
      this.projects = projects;

      if (!this.project) {
        this.setProject(this.getDefaultProject());
      }
      this.$stopLoading('projects');
      return this.projects;
    },
    getProject(field) {
      if (!this.project) {
        return undefined;
      }
      return field ? this.project[field] : this.project;
    },
    getProjectBy(field, value) {
      return field === 'ID' ? this.projects.byId[value] : this.projects.find(project => project[field] === value);
    },
    setProjectDebounce(project) {
      if (project !== this.project) {
        this.$startLoading('projects');
        this._setProjectDebounce(project);
      }
    },
    _setProjectDebounce: debounce(function setProjectDebounce(project) {
      this.setProject(project);
      this.$stopLoading('projects');
    }, 200),
    setProject(project) {
      this.project = project;
    },
    setAllProjectsItem(name) {
      this.projects.allProjectsItem.Name = name;
    },
    getDefaultProject() {
      return this.projects.default;
    },
    setDefaultProject(project) {
      this.projects.default = project;
    },
  },
  watch: {
    project() {
      if (!this.project) {
        this.$nextTick(() => {
          this.setProject(this.getDefaultProject());
        });
      }
    },
  },
};
